/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const OrderDirection = {
    ASC: 'ASC',
    DESC: 'DESC'
} as const;
export type OrderDirection = typeof OrderDirection[keyof typeof OrderDirection];


export function instanceOfOrderDirection(value: any): boolean {
    for (const key in OrderDirection) {
        if (Object.prototype.hasOwnProperty.call(OrderDirection, key)) {
            if (OrderDirection[key as keyof typeof OrderDirection] === value) {
                return true;
            }
        }
    }
    return false;
}

export function OrderDirectionFromJSON(json: any): OrderDirection {
    return OrderDirectionFromJSONTyped(json, false);
}

export function OrderDirectionFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrderDirection {
    return json as OrderDirection;
}

export function OrderDirectionToJSON(value?: OrderDirection | null): any {
    return value as any;
}

export function OrderDirectionToJSONTyped(value: any, ignoreDiscriminator: boolean): OrderDirection {
    return value as OrderDirection;
}

